const PHONE_LG_HEIGHT = 764;
const PHONE_XS_HEIGHT = 441;

export { PHONE_LG_HEIGHT, PHONE_XS_HEIGHT };
